import AsyncStorage from '@react-native-async-storage/async-storage';
import { JsonServiceClient } from '@servicestack/client';
import Constants from 'expo-constants';
import { Platform } from 'react-native';

class ServiceStackGateway {
  private client = new JsonServiceClient(Constants.manifest?.extra?.apiBaseUrl);

  constructor() {
    this.init().then();
  }

  private saveTokens = async (oldBearer: string) => {
    if (Platform.OS === 'web') {
      return;
    }
    if (oldBearer !== this.client.bearerToken) {
      await AsyncStorage.setItem(
        'tokens',
        JSON.stringify({
          bearer: this.client.bearerToken,
          refresh: this.client.refreshToken,
        })
      );
    }
  };

  private async init() {
    if (Platform.OS === 'web') {
      return;
    }
    const tokens = (await AsyncStorage.getItem('tokens')) ?? '';
    if (!tokens) {
      return;
    }
    const parsedTokens = JSON.parse(tokens);
    this.client.refreshToken = parsedTokens.refresh;
    this.client.bearerToken = parsedTokens.bearer;
  }

  public async get<T>(request: any): Promise<T> {
    const oldBearerToken = this.client.bearerToken;
    const response = await this.client.get<T>(request);
    this.saveTokens(oldBearerToken).then();
    return response;
  }

  public async post<T>(request: any): Promise<T> {
    const oldBearerToken = this.client.bearerToken;
    const response = await this.client.post<T>(request);
    this.saveTokens(oldBearerToken).then();
    return response;
  }
}

export default new ServiceStackGateway();
